import {INextAppointment} from '../infrastructure/dtos/Appointments';

export const handleClickOpenGMaps = (appointment: INextAppointment): void => {
  const lat = Number(appointment.coordinates_medical_office?.latitude)
  const lng = Number(appointment.coordinates_medical_office?.longitude)
  const url = `https://www.google.com/maps/place/${lat},${lng}`
  window.open(url, '_blank')
}
